export const AUTH_TOKEN = 'auth-token'
export const SELECTED_BRANCH = 'selected-branch'
export const PERMISSIONS = 'permissions'
export const HOOK_URL = 'hook-url'
export const OCI = 'oci'

export const accountManagers = [
  {
    name: 'Alexander Zuidam',
    firstName: 'Alexander',
    lastName: 'Zuidam',
    email: 'alexander@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Irene Zondag',
    firstName: 'Irene',
    lastName: 'Zondag',
    email: 'irene@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Jeffrey Hilgeman',
    firstName: 'Jeffrey',
    lastName: 'Hilgeman',
    email: 'jeffrey@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Jan Huisman',
    firstName: 'Jan',
    lastName: 'Huisman',
    email: 'jan.huisman@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Karin Zuurmond',
    firstName: 'Karin',
    lastName: 'Zuurmond',
    email: 'karin.zuurmond@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Linda Dronkert',
    firstName: 'Linda',
    lastName: 'Dronkert',
    email: 'linda@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Paul Kaars',
    firstName: 'Paul',
    lastName: 'Kaars',
    email: 'paul@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Ronald Kersseboom',
    firstName: 'Ronald',
    lastName: 'Kersseboom',
    email: 'ronald@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Rogier Meijer',
    firstName: 'Rogier',
    lastName: 'Meijer',
    email: 'rogier@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Rosan Vroege',
    firstName: 'Rosan',
    lastName: 'Vroege',
    email: 'rosan@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Sabrina Jansen',
    firstName: 'Sabrina',
    lastName: 'Jansen',
    email: 'sabrina@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Sammy Meyer',
    firstName: 'Sammy',
    lastName: 'Meyer',
    email: 'sammy@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Tim van den Broek',
    firstName: 'Tim',
    lastName: 'van den Broek',
    email: 'tim@kaarskoffie.nl',
    phone: '0182-308000'
  },
  {
    name: 'Anouk Smit',
    firstName: 'Anouk',
    lastName: 'Smit',
    email: 'anouk.smit@kaarskoffie.nl',
    phone: '0182-308000'
  }
]



// WEBPACK FOOTER //
// ./src/constants.js